import * as React from 'react';

import { IconProps } from '../Icon';

export const BellOutlineIcon = ({
  width,
  height,
  className,
  color,
}: IconProps) => (
  <svg
    className={className}
    color={color}
    height={height}
    id="Layer_1"
    version="1.1"
    viewBox="0 0 24 24"
    width={width}
    xmlns="http://www.w3.org/2000/svg"
  >
    <path d="M12,23a2,2,0,0,0,2-2H10A2,2,0,0,0,12,23Z" />
    <path d="M20.924,18.383a1,1,0,0,0-.217-1.09L19,15.586V10a7,7,0,0,0-6-6.92V2a1,1,0,0,0-2,0V3.08A7,7,0,0,0,5,10v5.586L3.293,17.293A1,1,0,0,0,4,19H20A1,1,0,0,0,20.924,18.383ZM6.414,17l.293-.293A1,1,0,0,0,7,16V10a5,5,0,0,1,10,0v6a1,1,0,0,0,.293.707l.293.293Z" />
  </svg>
);
